import { PapiDaSharedDeviationSubmitInit } from '@wix/da-papi-types';
import { ArtsAndCraftsDeviationFieldName, ArtsAndCraftsDeviationFormFields } from '../types';

const DEFAULT_VALUES = {
  [ArtsAndCraftsDeviationFieldName.DISPLAY_RESOLUTION]: 0,
  [ArtsAndCraftsDeviationFieldName.PRICE]: 20,
  [ArtsAndCraftsDeviationFieldName.ADD_WATERMARK]: false,
  [ArtsAndCraftsDeviationFieldName.OPEN_FOR_ORDERS]: true,
};

export function useDefaultValues(
  initResponse?: PapiDaSharedDeviationSubmitInit
): Partial<ArtsAndCraftsDeviationFormFields> {
  const deviation = initResponse?.deviation;

  if (deviation) {
    const { tags, displayIndex } = initResponse;
    let description = deviation.extended?.descriptionText;
    if (description && description.html.type === 'writer' && description.html.markup === '') {
      description = undefined;
    }
    return {
      [ArtsAndCraftsDeviationFieldName.TITLE]: deviation.title,
      [ArtsAndCraftsDeviationFieldName.DESCRIPTION]: description
        ? () => JSON.stringify(description)
        : undefined,
      [ArtsAndCraftsDeviationFieldName.MATURE_CONTENT]: deviation.isMature,
      [ArtsAndCraftsDeviationFieldName.TAGS]: tags?.map(tag => tag.name),
      [ArtsAndCraftsDeviationFieldName.PRICE]: deviation.extended?.originals?.basePrice,
      [ArtsAndCraftsDeviationFieldName.DISPLAY_RESOLUTION]: displayIndex,
      [ArtsAndCraftsDeviationFieldName.OPEN_FOR_ORDERS]: deviation.extended?.originals?.isOpen,
      [ArtsAndCraftsDeviationFieldName.ADD_WATERMARK]: deviation.extended?.hasWatermark,
      [ArtsAndCraftsDeviationFieldName.QUESTIONS]: deviation.extended?.originals?.questionnaire,
    };
  } else {
    return {
      ...DEFAULT_VALUES,
      [ArtsAndCraftsDeviationFieldName.QUESTIONS]: [],
    };
  }
}
